import React from 'react';
import { CartItem } from '../context/CartContext';
interface OrderSummaryProps {
  items: CartItem[];
  totalPrice: number;
  totalItems: number;
}
export const OrderSummary: React.FC<OrderSummaryProps> = ({
  items,
  totalPrice,
  totalItems
}) => {
  // Calculate shipping, tax, and total
  const shipping = 0; // Free shipping
  const taxRate = 0.07; // 7% tax rate
  const tax = totalPrice * taxRate;
  const orderTotal = totalPrice + tax + shipping;
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6" data-id="element-127">
      <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-128">Order Summary</h2>
      <div className="flow-root" data-id="element-129">
        <ul className="-my-4 divide-y divide-gray-200" data-id="element-130">
          {items.map(item => <li key={item.id} className="flex py-4" data-id="element-131">
              <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-md border border-gray-200" data-id="element-132">
                <img src={item.image} alt={item.name} className="h-full w-full object-cover object-center" data-id="element-133" />
              </div>
              <div className="ml-4 flex flex-1 flex-col" data-id="element-134">
                <div data-id="element-135">
                  <div className="flex justify-between text-sm font-medium text-gray-900" data-id="element-136">
                    <h3 data-id="element-137">{item.name}</h3>
                    <p className="ml-4" data-id="element-138">
                      ${(item.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-139">
                    Size: {item.size}
                  </p>
                </div>
                <div className="flex flex-1 items-end justify-between text-sm" data-id="element-140">
                  <p className="text-gray-500" data-id="element-141">Qty {item.quantity}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
      <div className="border-t border-gray-200 pt-4 mt-6" data-id="element-142">
        <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-143">
          <p data-id="element-144">
            Subtotal ({totalItems} {totalItems === 1 ? 'item' : 'items'})
          </p>
          <p data-id="element-145">${totalPrice.toFixed(2)}</p>
        </div>
        <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-146">
          <p data-id="element-147">Shipping</p>
          <p data-id="element-148">{shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}</p>
        </div>
        <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-149">
          <p data-id="element-150">Tax (7%)</p>
          <p data-id="element-151">${tax.toFixed(2)}</p>
        </div>
        <div className="flex justify-between text-base font-medium text-gray-900 mt-4 pt-4 border-t border-gray-200" data-id="element-152">
          <p data-id="element-153">Order total</p>
          <p data-id="element-154">${orderTotal.toFixed(2)}</p>
        </div>
      </div>
      <div className="mt-6" data-id="element-155">
        <div className="rounded-md bg-gray-50 p-4" data-id="element-156">
          <div className="flex items-center" data-id="element-157">
            <div className="ml-3 text-sm text-gray-600" data-id="element-158">
              <p data-id="element-159">
                Your personal data will be used to process your order, support
                your experience throughout this website, and for other purposes
                described in our privacy policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};